import * as React from "react"

import { IDeal } from "shared/hubrise/models"

import Delete from "./Delete"
import Preview from "./Preview"

const Commands = ({ deal }: { deal: IDeal }): JSX.Element => (
  <>
    <Preview deal={deal} />
    <Delete deal={deal} />
  </>
)

export default Commands
